<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding:20px;height: 400px;overflow-y: scroll" v-loading="tableLoading">

      <el-col :span="24" style="padding:5px 0">
        <el-col :span="20">
          <Daterange :startTime="startTime"  is-datetime="datetime" :endTime="endTime" @dataChange='dataChange'></Daterange>
        </el-col>
        <el-col :span="4">
          <el-button style="float: right;" size="mini" type="primary" @click="submit">搜索</el-button>
        </el-col>
      </el-col>

      <div style="height: 10px;"></div>

      <el-table :data="scoreDetailList" border>
        <el-table-column prop="indexName" width="180"  label="分析项目" ></el-table-column>
        <el-table-column prop="indexValOriginal"  label="得分" ></el-table-column>
      </el-table>

      <div style="height: 10px;"></div>
      <el-table :data="reportIndexList" border >
        <el-table-column prop="indexName" width="180"  label="分析项目" ></el-table-column>
        <el-table-column prop="normalFlagTips"  label="提示" ></el-table-column>
      </el-table>

      <div v-if="breathRateTrendsVo !=null">
        <div style="height: 10px;"></div>
        <div>呼吸情况：{{breathRateTrendsVo.avgLabel}}[平均值:{{breathRateTrendsVo.avg}}]</div>
        <el-table  :data="breathRateTrendsVo.dataList" border >
          <el-table-column prop="date" width="180"  label="日期" ></el-table-column>
          <el-table-column prop="avg"  label="平均值" ></el-table-column>
          <el-table-column prop="max"  label="最大值" ></el-table-column>
          <el-table-column prop="min"  label="最小值" ></el-table-column>
        </el-table>
      </div>

      <div v-if="heartRateTrendsVo !=null">
        <div style="height: 10px;"></div>
        <div>心率情况：{{heartRateTrendsVo.avgLabel}}[平均值:{{heartRateTrendsVo.avg}}]</div>
        <el-table  :data="heartRateTrendsVo.dataList" border >
          <el-table-column prop="date" width="180"  label="日期" ></el-table-column>
          <el-table-column prop="avg"  label="平均值" ></el-table-column>
          <el-table-column prop="max"  label="最大值" ></el-table-column>
          <el-table-column prop="min"  label="最小值" ></el-table-column>
        </el-table>
      </div>


    </div>
  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Daterange from "@/components/Daterange";

export default {
  name: "SleepQualityPage",
  data() {
    return {
      tableLoading:false,
      userCode: '',


      tableData:[],
      totalItems: 0,
      pageIndex:'',
      pageSize:20,
      currentPage:1,

      startTime:'',
      endTime:'',

      breathRateTrendsVo:null,
      heartRateTrendsVo:null,
      reportIndexList:[],
      scoreDetailList:[],

    }
  },
  components: {
    Daterange
  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.endTime=timefilters(new Date())
      this.startTime=timefilters(new Date(new Date()-1000 * 60 * 60 * 24 * 7))
      this.getSleepQualityPage();
    },
    dataChange(val){
      this.startTime=val[0]
      this.endTime=val[1]
    },
    closeSelf() {
      this.$emit("closeSleepQualityPage");
    },


    getAddTime(row){
      return timefilters(row.addTime)
    },
    getStartBedtime(row){
      return timefilters(row.startBedTime)
    },
    getEndBedtime(row){
      return timefilters(row.endBedTime)
    },
    getSleepTime(row){
      return timefilters(row.sleepTime)
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getSleepQualityPage();
    },
    submit(){
      this.getSleepQualityPage();
    },
    getSleepQualityPage(){
      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "DeviceQLSign/reportByUserCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode: this.userCode,
          startTime:this.startTime,
          endTime:this.endTime,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {

              this.breathRateTrendsVo=response.data.data.breathRateTrendsVo;
              this.heartRateTrendsVo=response.data.data.heartRateTrendsVo;
              this.reportIndexList = response.data.data.reportIndexList;
              this.scoreDetailList = response.data.data.scoreDetailList;



            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },





  }


}
</script>

<style lang="scss" scoped>

</style>
